import { render, staticRenderFns } from "./user-info.vue?vue&type=template&id=3ddb638d&scoped=true&"
import script from "./user-info.vue?vue&type=script&lang=ts&"
export * from "./user-info.vue?vue&type=script&lang=ts&"
import style0 from "./user-info.vue?vue&type=style&index=0&id=3ddb638d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddb638d",
  null
  
)

export default component.exports